import type { User } from '@/types/auth';

const SKIP_KEY = 'gateco_profile_skipped';

/**
 * Whether the one-time post-signup profiling step should be shown.
 *
 * Server-driven: once the backend sets ``profile_completed_at`` (on submit OR
 * skip) the step never shows again. A localStorage flag is a per-device
 * fallback so a skip persists even before the next /me refresh.
 */
export function needsProfile(user: User | null): boolean {
  if (!user) return false;
  if (user.profile_completed_at) return false;
  if (typeof localStorage !== 'undefined' && localStorage.getItem(SKIP_KEY) === '1') return false;
  return true;
}

export function markProfileSkippedLocally(): void {
  if (typeof localStorage !== 'undefined') localStorage.setItem(SKIP_KEY, '1');
}
